module.exports = __webpack_public_path__ + "static/ck_artisan-45de53e683d42a0b8a042099dd4e046f.jpg";